import { render, staticRenderFns } from "./ppob.vue?vue&type=template&id=1c3fcda7"
import script from "./ppob.vue?vue&type=script&lang=js"
export * from "./ppob.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1c3fcda7')) {
      api.createRecord('1c3fcda7', component.options)
    } else {
      api.reload('1c3fcda7', component.options)
    }
    module.hot.accept("./ppob.vue?vue&type=template&id=1c3fcda7", function () {
      api.rerender('1c3fcda7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "layouts/ppob.vue"
export default component.exports